import LazyLoad from 'react-lazyload';
import IndexLayout from '../layouts';
import Wrapper from '../components/Wrapper';
import SiteNav from '../components/header/SiteNav';

import { graphql } from 'gatsby';
import Img from 'gatsby-image';

import { SiteHeader, outer, inner, SiteMain } from '../styles/shared';
import * as React from 'react';
import { css } from '@emotion/core';
import { PostFullHeader, PostFullTitle, NoImage, PostFull } from '../templates/post';
import { PostFullContent } from '../components/PostContent';
import Footer from '../components/Footer';
import Helmet from 'react-helmet';
import styled from '@emotion/styled';

//import ShareButtons from '../components/ShareButtons';
import MoreGoodies from '../components/more-goodies/MoreGoodies';
import BackToTop from '../components/BackToTop';

export const query = graphql`
  query {
    file(relativePath: { eq: "covers/creepy-spooky-overlays.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1800) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`;

const ThumbWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  overflow: hidden;
  grid-gap: 0.75rem;

  img {
    object-fit: cover;
    height: 200px;
    width: 100%;
  }
  a {
    box-shadow: none;

    color: #382757;
    transition: color 0.25s ease-out;
  }
  p {
    margin-bottom: 0;
  }

  @media (max-width: 650px) {
    grid-template-columns: 1fr 1fr;

    img {
      object-fit: fill;
    }
  }
`;

const PageTemplate = css`
  .header-image {
    margin-bottom: 4.5rem;
    box-shadow: 0 10px 20px -16px #382757;
  }

  .site-main {
    background #fff;
    padding-bottom: 4vw;
  }

  .post-content {
    max-width: 1000px;
    margin: 0 auto;
  }
  .post-content .large-key .key {
    font-size: 3rem;
    padding: 15px;
    margin-top: 20px;
    display: inline-block;
    border-radius: 6px;
  }
  .large-key {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    margin-top: 4rem;
  }

  @media(max-width: 400px) {
    .large-key {
      grid-template-columns: 1fr 1fr;
    }
  }

  h2::before {
    display: none !important;
  }
`;

const CreepySpookyOverlays: React.FunctionComponent = ({ data }) => (
  <IndexLayout>
    <Helmet>
      <title>37 Free Creepy/Spooky Overlays for Photoshop | Giggster Guide</title>
      <meta
        name="description"
        content="A collection with 37 high-resolution spooky and creepy overlays to use in your photo edits in Photoshop to add grit and texture to your images."
      />

      <meta property="og:site_name" content="Giggster Guide" />
      <meta property="og:type" content="article" />
      <meta property="og:title" content="37 Free Creepy/Spooky Overlays for Photoshop" />
      <meta
        property="og:description"
        content="A collection with 37 high-resolution spooky and creepy overlays to use in your photo edits in Photoshop to add grit and texture to your images."
      />
      <meta property="og:url" content="https://giggster.com/guide/creepy-spooky-overlays/" />
      <meta property="og:image" content="https://giggster.com/guide/covers/creepy-spooky-overlays.jpg" />
      <meta property="article:publisher" content="https://www.facebook.com/giggsterHQ" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="37 Free Creepy/Spooky Overlays for Photoshop" />
      <meta
        name="twitter:description"
        content="A collection with 37 high-resolution spooky and creepy overlays to use in your photo edits in Photoshop to add grit and texture to your images."
      />
      <meta name="twitter:url" content="https://giggster.com/guide/creepy-spooky-overlays/" />
      <meta name="twitter:image" content="https://giggster.com/guide/covers/creepy-spooky-overlays.jpg" />
      <meta name="twitter:site" content="@Giggster" />
      <meta name="twitter:creator" content="@Giggster" />
    </Helmet>
    <Wrapper css={PageTemplate}>
      <header css={[outer, SiteHeader]}>
        <div css={inner}>
          <SiteNav />
        </div>
      </header>
      <main id="site-main" className="site-main" css={[SiteMain, outer]}>
        <article className="post page" css={[PostFull, NoImage]}>
          <PostFullHeader>
            <PostFullTitle>37 Free Creepy/Spooky Overlays for Photoshop</PostFullTitle>
            <h2 className="b3">
              Some scary-looking high-definition overlay images to use to add interesting scary
              textures to your photos.
            </h2>
            <Img
              className="header-image"
              fluid={data.file.childImageSharp.fluid}
              alt="Example of some creepy overlays"
            />
            {/*<ShareButtons
              title={'37 Free Creepy/Spooky Overlays for Photoshop'}
              slug={'/creepy-spooky-overlays/'}
              imgSrc={'covers/creepy-spooky-overlays.jpg'}
            />*/}
          </PostFullHeader>

          <PostFullContent className="post-full-content">
            <div className="post-content">
              <p>
                I went out and was able to capture interesting abstract textures that are
                creepy/spooky-looking. These make a perfect addition to photos that have a
                dark/scary tone, to add that little bit of extra abstract texture element.
              </p>

              <p>
                You'll find here a pack with 37 high-resolution creepy overlays that are absolutely
                free to use. Upon request, I can create more too if this pack ends up being popular.
              </p>

              <p>
                To add one of those overlays to your photo in Photoshop, just add it as a new layer
                on top of your image and then turn the blend mode of the layer to <em>Screen</em>.
                You can then tweak the opacity of that layer so that you get something that works
                for your image, and also don't hesitate to erase parts of the overlays where it
                doesn't compliment the photo. To learn more about how to use textures and overlays
                in Photoshop, you can <a href="/guide/retouching/using-textures/">refer to this post</a>.
              </p>

              <hr />
           
              <h2 className="text-center">Free Creepy/Spooky Overlays</h2>
              <p>
                Below you can see thumbnails for the 37 creepy overlays. Just click on any of the
                thumbnails to download a full high-resolution version of the texture.
              </p>
              <ThumbWrapper>
                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-1.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-1.jpg"
                        alt="Creepy/spooky overlay 1"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-2.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-2.jpg"
                        alt="Creepy/spooky overlay 2"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-3.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-3.jpg"
                        alt="Creepy/spooky overlay 3"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-4.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-4.jpg"
                        alt="Creepy/spooky overlay 4"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-5.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-5.jpg"
                        alt="Creepy/spooky overlay 5"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-6.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-6.jpg"
                        alt="Creepy/spooky overlay 6"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-7.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-7.jpg"
                        alt="Creepy/spooky overlay 7"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-8.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-8.jpg"
                        alt="Creepy/spooky overlay 8"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-9.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-9.jpg"
                        alt="Creepy/spooky overlay 9"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-10.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-10.jpg"
                        alt="Creepy/spooky overlay 10"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-11.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-11.jpg"
                        alt="Creepy/spooky overlay 11"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-12.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-12.jpg"
                        alt="Creepy/spooky overlay 12"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-13.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-13.jpg"
                        alt="Creepy/spooky overlay 13"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-14.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-14.jpg"
                        alt="Creepy/spooky overlay 14"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-15.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-15.jpg"
                        alt="Creepy/spooky overlay 15"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-16.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-16.jpg"
                        alt="Creepy/spooky overlay 16"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-17.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-17.jpg"
                        alt="Creepy/spooky overlay 17"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-18.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-18.jpg"
                        alt="Creepy/spooky overlay 18"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-19.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-19.jpg"
                        alt="Creepy/spooky overlay 19"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-20.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-20.jpg"
                        alt="Creepy/spooky overlay 20"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-21.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-21.jpg"
                        alt="Creepy/spooky overlay 21"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-22.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-22.jpg"
                        alt="Creepy/spooky overlay 22"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-23.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-23.jpg"
                        alt="Creepy/spooky overlay 23"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-24.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-24.jpg"
                        alt="Creepy/spooky overlay 24"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-25.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-25.jpg"
                        alt="Creepy/spooky overlay 25"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-26.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-26.jpg"
                        alt="Creepy/spooky overlay 26"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-27.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-27.jpg"
                        alt="Creepy/spooky overlay 27"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-28.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-28.jpg"
                        alt="Creepy/spooky overlay 28"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-29.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-29.jpg"
                        alt="Creepy/spooky overlay 29"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-30.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-30.jpg"
                        alt="Creepy/spooky overlay 30"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-31.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-31.jpg"
                        alt="Creepy/spooky overlay 31"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-32.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-32.jpg"
                        alt="Creepy/spooky overlay 32"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-33.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-33.jpg"
                        alt="Creepy/spooky overlay 33"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-34.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-34.jpg"
                        alt="Creepy/spooky overlay 34"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-35.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-35.jpg"
                        alt="Creepy/spooky overlay 35"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-36.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-36.jpg"
                        alt="Creepy/spooky overlay 36"
                      />
                    </a>
                  </div>
                </LazyLoad>

                <LazyLoad height={200}>
                  <div className="text-center">
                    <a
                      target="_blank"
                      download="true"
                      href="https://purple11.s3.amazonaws.com/creepy-spooky-overlays/creepy-overlay-37.jpg"
                      rel="noreferrer noopener"
                    >
                      <img
                        src="/guide/images/creepy-spooky-overlays/creepy-overlay-37.jpg"
                        alt="Creepy/spooky overlay 37"
                      />
                    </a>
                  </div>
                </LazyLoad>
              </ThumbWrapper>
            </div>
          </PostFullContent>
        </article>
        <MoreGoodies slug="creepy-spooky-overlays" />
      </main>
      <BackToTop />
      <Footer />
    </Wrapper>
  </IndexLayout>
);

export default CreepySpookyOverlays;
